import i18next from 'i18next';
import IntPhoneInput from '../../phone';

export function Step5Personal({ formData, updateFormData, quotationDetails, phoneError, t }) {
    const currentLanguage = !localStorage.getItem('lng') ? i18next.language : localStorage.getItem('lng');

    const handlePhoneChange = (value) => {
        updateFormData({ customer_phone: value });
    };

    const handleAcceptanceChange = (e) => {
        updateFormData({ personal_data: e.target.checked });
    };

    const handlePaymentTermsChange = (e) => {
        updateFormData({ payment_terms: e.target.checked });
    };

    return (
        <div className="step-content">
            <h3 className="mb-3">{t('stepper.step5.title')}</h3>
            <div className="row">
                <div className="col-md-6 form-group">
                    <input
                        type="text"
                        name="customer_name"
                        placeholder={t('contact.fields.name.placeholder')}
                        value={formData.customer_name}
                        onChange={(e) => updateFormData({ customer_name: e.target.value })}
                        className="form-control"
                        required
                    />
                    <label className="form__label">{t('contact.fields.name.label')} *</label>
                </div>
                <div className="col-md-6 form-group mt-1 mt-md-0">
                    <input
                        type="text"
                        className="form-control"
                        name="customer_surname"
                        placeholder={t('contact.fields.surname.placeholder')}
                        value={formData.customer_surname}
                        onChange={(e) => updateFormData({ customer_surname: e.target.value })}
                        required
                    />
                    <label className="form__label">{t('contact.fields.surname.label')} *</label>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-md-6 form-group">
                    <input
                        type="email"
                        className="form-control"
                        name="customer_email"
                        placeholder={t('contact.fields.email.placeholder')}
                        value={formData.customer_email}
                        onChange={(e) => updateFormData({ customer_email: e.target.value })}
                        required
                    />
                    <label className="form__label">{t('contact.fields.email.label')} *</label>
                </div>
                <div className="col-md-6 form-group mt-1 mt-md-0">
                    <IntPhoneInput name="customer_phone" value={formData.customer_phone} onChange={handlePhoneChange} />
                    <label className="form__label">{t('contact.phone')} *</label>
                    {phoneError && (
                        <span
                            className="text-danger position-absolute"
                            style={{ fontSize: '10px', letterSpacing: '0.5px' }}
                        >
                            {t('contact.phone_error')}
                        </span>
                    )}
                </div>
            </div>
            <div className="form-group mt-1 mb-2" style={{ height: 'fit-content' }}>
                <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    placeholder={t('contact.fields.message.placeholder')}
                    value={formData.message}
                    onChange={(e) => updateFormData({ message: e.target.value })}
                ></textarea>
                <label className="form__label">{t('contact.fields.message.label')}</label>
            </div>
            <div className="d-flex align-items-center pb-2">
                <input
                    className="form-check-input mt-0"
                    style={{
                        marginRight: '0.5rem',
                        aspectRatio: '1',
                    }}
                    type="checkbox"
                    name="personal_data"
                    checked={formData.personal_data}
                    onChange={handleAcceptanceChange}
                    required
                />
                <label className="form-check-label" htmlFor="personal_data">
                    {t('contact.fields.acceptance_data.text_personal_data')}{' '}
                    <a
                        href={
                            currentLanguage === 'it'
                                ? 'document/Privacy_ParkingTransferLivorno.pdf'
                                : 'document/Privacy_ParkingTransferLivorno_EN.pdf'
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('contact.fields.acceptance_data.link')}
                    </a>
                    *
                </label>
            </div>
            <div className="d-flex align-items-center pb-2">
                <input
                    className="form-check-input mt-0"
                    style={{
                        marginRight: '0.5rem',
                        aspectRatio: '1',
                    }}
                    type="checkbox"
                    name="payment_terms"
                    checked={formData.payment_terms}
                    onChange={handlePaymentTermsChange}
                    required
                />
                <label className="form-check-label" htmlFor="payment_terms">
                    {t('contact.fields.acceptance_data.text_payment_terms')}{' '}
                    <a
                        href={
                            currentLanguage === 'it'
                                ? 'document/PaymentConditions_ParkingTransferLivorno.pdf'
                                : 'document/PaymentConditions_ParkingTransferLivorno_EN.pdf'
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('contact.fields.acceptance_data.link')}
                    </a>
                    *
                </label>
            </div>
            <div className="mt-3 mb-4 p-3 rounded bg-light">
                <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: '14px' }}>{t('contact.fields.total_price')}</span>
                    <strong style={{ fontSize: '20px' }}>€{quotationDetails?.total_quotation?.toFixed(2)}</strong>
                </div>
            </div>
        </div>
    );
}
